import { IMarketProduct } from '@/domain/bankwatch';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export interface MarketProductsState {
  allMarketProducts: IMarketProduct[];
  selectedMarketProduct: IMarketProduct | null;
  isFetching: boolean;
  error: string | null;
}

const state: MarketProductsState = {
  allMarketProducts: [],
  selectedMarketProduct: null,
  isFetching: false,
  error: null
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
